import moment from 'moment'

export const DateConstants = {

  YYYY_MM_DD: 'YYYY-MM-DD',
  DD_MM_YYYY: 'DD/MM/YYYY',
  DD_MM_YYYY_HH_MM: 'DD/MM/YYYY HH:mm',
  DD_MM_YYYY_T: 'YYYY-MM-DDTHH:mm'
}

export const DateUtils = {

  create: date => {
    return moment(date)
  },

  formatDate: (date, pattern) => {
    if (pattern) {
      return moment(date).format(pattern)
    }
    return moment(date).format('YYYY-MM-DD')
  },

  getDatesInInterval: (startDate, endDate, interval, unit) => {
    const dates = []

    let momentDate = moment(startDate)
    while (momentDate.isAfter(endDate)) {
      dates.push(momentDate.toDate())
      momentDate.add(interval, unit)
    }

    if (momentDate.isAfter(moment(endDate))) {
      dates.push(endDate)
    }

    return dates
  },

  parse: (dateString, pattern) => {
    return moment(dateString, pattern)
  },

  verificarNascimentoDataValida: dataNascimento => {
    return DateUtils.parse(dataNascimento, 'DD/MM/YYYY').isValid()
  }

}

export default DateUtils
